import * as React from "react";
import { connect, Provider } from "react-redux";
import { UserInfo } from "../../../Login/common/defaults";
import Api from "../../../../services/Api";
import { ApiResponse } from "apisauce";
import { DateRangePicker } from "react-dates";
import CommentModal from "../../../CommentModal/CommentModal";
import {
  IAppRouteLocation,
  IAuditLogBase,
  IExportColumnMap,
  IReport,
  PagedResultsRequest
} from "../../../../common/sharedTypes";
import {
  createManagementAuditLog,
  getKeywordsByCrashKey
} from "../redux-objects/actions";
import * as urls from "../../../shared/urls";
import { IWorkflowStepDetails } from "../../common/types";
import { Button, Col, Form, Modal, Tab, Tabs } from "react-bootstrap";
import {
  ElasticIndices,
  LogCategoryEnum,
  LoggingLevel
} from "../../../../services/Enums/shared";
import { showLoadingWithMessage } from "../../../Application/redux-objects/actions";
import moment from "moment";
import { toast } from "react-toastify";
import ViewTvalFormButton from "../../../shared/ViewTvalFormButton/ViewTvalFormButton";
import "../management.css";
import rootReducer from "../../../../store/Reducers";
import store from "../../../../store/Store";
import CommentsButton from "../../../Comments/CommentsButton";
import ViewAllButton from "../../../DocumentViewer/ViewAllButton";
import { isGranted, permissions } from "../../../../services/permissionChecker";
import AddEditKeywordsModal from "../presentation/AddEditKeywordsModal";
import PullReportModal from "../presentation/PullReportModal";
import MergedIndicator from "../../common/MergedIndicator";
import PagedDatatable from "../../../PagedDataTable";
import {
  ExtendedManagementQueueItem,
  IManagementQueueItemResponse,
  IManagementQueuePagedResponse,
  ManagementQueuePagedRequest,
  ManagementReportDataRequest
} from "../business-objects/common";

import { TableColumn } from "react-data-table-component/dist/DataTable/types";
import LocalStorageUtils from "../../common/LocalStorageUtils";
import CompletedIndicator from "../../common/CompletedIndicator";
import DriverReportMergedIndicator from "../../common/DriverReportMergedIndicator";

const reduxStore = store({}, rootReducer);

export interface IManagementLog extends IAuditLogBase {
  reportId: number;
  action: string;
  userComment: string;
}

enum eReportLink {
  ToggleLinkReports,
  SaveReportLinks
}

enum eLinkReportToggleStatus {
  None,
  LinkReports,
  UnlinkReports,
  Done
}

interface IManagementQueueControllerPagedOwnProps {
  history: any;
  location: any;
  managementStartDate: any;
  managementEndDate: any;
}

interface IManagementQueueControllerPagedPropsFromState {
  webServiceURL: string;
  currentUser: UserInfo;
  workflowStepsLoading: boolean;
  workflowSteps: IWorkflowStepDetails[];
  elasticSearchURL: string;
  linkReport: IReport;
}

interface IManagementQueueControllerPagedPropsFromDispatch {
  showLoadingWithMessage: (show: boolean, message?: string) => void;
  createManagementAuditLog: (managementLog: IAuditLogBase, value: any) => void;
  getKeywordsByCrashKey: (originalCrashKey: string) => void;
  getReport?: (url: string) => Promise<void>;
}

const initialState = {
  data: [],
  deletedReports: [],
  showCommentModal: false,
  comment: "",
  pendingAction: "",
  reportIdValue: 0,
  reportIdsToLink: [],
  reportIdsToUnLink: [],
  reportLinkStatus: eReportLink.ToggleLinkReports,
  showLinkChkbxColumn: false,
  showUnLinkChbxColumn: false,
  linkReportStatus: eLinkReportToggleStatus.None,
  startDate: moment(
    moment().startOf("month").format("DD/MM/YYYY"),
    "DD/MM/YYYY"
  ),
  endDate: moment(moment().endOf("month").format("DD/MM/YYYY"), "DD/MM/YYYY"),
  focusedInput: null,
  showLinkByCrashKey: false,
  manualLinkToReportId: null,
  originalCrashKeyToLink: "",
  originalCrashKeyValid: false,
  showAddEditKeywordsModal: false,
  tabKey: "Management",
  showPullReportModal: false,
  loadingManageQueue: false,
  loadingDeleteQueue: false,
  manageQueueTotal: 0,
  deleteQueueTotal: 0,
  managePagingCriteria: {
    itemsPerPage: 10,
    pageNumber: 1,
    searchCriteria: null,
    orderByField: "originalCrashKey",
    orderDescending: false
  },
  deletedPagingCriteria: {
    itemsPerPage: 10,
    pageNumber: 1,
    searchCriteria: null,
    orderByField: "CrashKey",
    orderDescending: false
  }
};

type ManagementQueueState = Readonly<typeof initialState>;

type IManagementQueueControllerPagedProps = IManagementLog &
  IManagementQueueControllerPagedOwnProps &
  IManagementQueueControllerPagedPropsFromState &
  IManagementQueueControllerPagedPropsFromDispatch;

class ManagementQueueControllerPaged extends React.Component<
  IManagementQueueControllerPagedProps,
  ManagementQueueState
> {
  public constructor(props: IManagementQueueControllerPagedProps) {
    super(props);
    this.state = initialState;
  }

  private rowData: any;
  private id: number;
  private pendingAction: string;
  private reportIdValue: number;
  private startDateVariable: string = "managementStartDate";
  private endDateVariable: string = "managementEndDate";
  private managementPageCriteriaVariable: string = 'managementPageCriteria';

  // Component LifeCycle methods
  async componentDidMount() {
  // --- 1) read dates from localStorage ---
  const startDate = await this.getLocalStorageItem(this.startDateVariable);
  const endDate = await this.getLocalStorageItem(this.endDateVariable);

  // --- 2) read paging criteria from sessionStorage ---
  let savedCriteria: any = null;
  try {
    const raw = sessionStorage.getItem(this.managementPageCriteriaVariable);
    savedCriteria = raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.log("Failed to parse saved paging criteria:", e);
    savedCriteria = null;
  }

  // Normalize criteria so UI inputs can be controlled safely
 const normalizedCriteria = savedCriteria
  ? {
      ...savedCriteria,
      searchCriteria: savedCriteria.searchCriteria ?? "",
      pageNumber: savedCriteria.pageNumber ?? 1,
      itemsPerPage: savedCriteria.itemsPerPage ?? 10,
      orderByField: savedCriteria.orderByField ?? "originalCrashKey",
      orderDescending: savedCriteria.orderDescending ?? false
    }
  : null;

  // Validate moment objects coming back from getLocalStorageItem
  const datesAreValid =
    !!startDate &&
    !!endDate &&
    typeof (startDate as any).isValid === "function" &&
    typeof (endDate as any).isValid === "function" &&
    (startDate as any).isValid() &&
    (endDate as any).isValid();

  // --- 3) build nextState (use any because your state type is Readonly<...>) ---
  const nextState: any = {};

  if (normalizedCriteria) {
    nextState.managePagingCriteria = normalizedCriteria;
  }

  if (datesAreValid) {
    nextState.startDate = startDate;
    nextState.endDate = endDate;
  }

  this.setState(nextState, () => {
    this.doSearch();
  });
}

  doSearch = () => {
    if(this.state.tabKey == "Deleted")
    {
      this.loadDeletedData();
    } else {
      this.loadManageData();
    }
  };

handleDatesChanged(startDate, endDate) {
  // store as ISO strings (or null)
  this.setLocalStorageItem(this.startDateVariable, startDate ? startDate.toISOString() : "");
  this.setLocalStorageItem(this.endDateVariable, endDate ? endDate.toISOString() : "");

  if (startDate && endDate) {
   this.setState(
      (s: any) => ({
        startDate,
        endDate,
        managePagingCriteria: { ...s.managePagingCriteria, pageNumber: 1 }
      }),
      () => this.doSearch()
    );
  }
}

  onCloseLinkByCrashKey = () => {
    this.setState({ showLinkByCrashKey: false });
  };

 loadManageData = async () => {
  this.setState({ loadingManageQueue: true });

  sessionStorage.setItem(
    this.managementPageCriteriaVariable,
    JSON.stringify(this.state.managePagingCriteria)
  );

  try {
    const request: ManagementQueuePagedRequest = {
      ...this.state.managePagingCriteria,
      startDate: this.state.startDate.toDate(),
      endDate: this.state.endDate.toDate(),
      getDeleted: false
    };

    const response: ApiResponse<IManagementQueuePagedResponse> =
      await Api.post(urls.GET_REPORTS_IN_MANAGEMENT_QUEUE_PAGED, request);

    if (!response || !response.ok) {
      const status = (response as any)?.status;
      const problem = (response as any)?.problem;

      alert(
        (response as any)?.data?.message ||
        (response as any)?.originalError?.message ||
        `Failed to load management queue${status ? ` (HTTP ${status})` : ""}${problem ? `: ${problem}` : ""}.`
      );

      this.setState({
        data: null,
        manageQueueTotal: 0
      });

      return;
    }

    const searchResult = response.data?.searchResult ?? [];

    if (searchResult.length === 0) {
      this.setState({
        data: null,
        manageQueueTotal: 0
      });
      return;
    }

    const detailPromises: Array<Promise<ExtendedManagementQueueItem | null>> =
      searchResult.map(x =>
        (async () => {
          try {
            const dataRequest: ManagementReportDataRequest = {
              workflowItemId: x.workflowItemId
            };

            const dataResponse: ApiResponse<IManagementQueueItemResponse> =
              await Api.post(urls.GET_MANAGEMENT_ITEM_DATA, dataRequest);

            if (!dataResponse || !dataResponse.ok || !dataResponse.data?.managementItem) {
              return null;
            }

            dataResponse.data.managementItem.order = x.order;
            return dataResponse.data.managementItem as ExtendedManagementQueueItem;
          } catch (e) {
            console.log("Failed to load management item:", x.workflowItemId, e);
            return null;
          }
        })()
      );

    const results = await Promise.all(detailPromises);

    const managementItems = results
      .filter((x): x is ExtendedManagementQueueItem => x != null)
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    this.setState({
      data: managementItems,
      manageQueueTotal: response.data?.totalResults ?? managementItems.length
    });

    if (managementItems.length === 0) {
      alert("No management items could be loaded. Please try again.");
    }
  } catch (ex) {
    console.log(ex);
    alert("Unexpected error loading management queue.");

    this.setState({
      data: null,
      manageQueueTotal: 0
    });
  } finally {
    this.setState({ loadingManageQueue: false });
  }
};



  getManageExportData = async () => {
    try {
      const request: ManagementQueuePagedRequest = {
        ...this.state.managePagingCriteria,
        pageNumber: 1,
        itemsPerPage: this.state.manageQueueTotal,
        startDate: this.state.startDate.toDate(),
        endDate: this.state.endDate.toDate(),
        getDeleted: false
      };

      const response: ApiResponse<IManagementQueuePagedResponse> =
        await Api.post(urls.GET_REPORTS_IN_MANAGEMENT_QUEUE_EXPORT, request);

      if (response.ok) {
        return response.data.managementItems || [];
      }
    } catch (ex) {
      console.log(ex);
    }
    return [];
  };

  loadDeletedData = async () => {
    this.setState({ loadingDeleteQueue: true });

    try {
      const request: ManagementQueuePagedRequest = {
        ...this.state.deletedPagingCriteria,
        startDate: this.state.startDate.toDate(),
        endDate: this.state.endDate.toDate(),
        getDeleted: true
      };

      const response: ApiResponse<IManagementQueuePagedResponse> =
        await Api.post(urls.GET_REPORTS_IN_MANAGEMENT_QUEUE_PAGED, request);


        if (response.ok) {
          if (response.data.searchResult && response.data.searchResult.length > 0) {
            let managementItems: ExtendedManagementQueueItem[] = [];
            response.data.searchResult.map(async x => {
              const dataRequest: ManagementReportDataRequest = { workflowItemId: x.workflowItemId, getDeleted: true };
              const dataResponse: ApiResponse<IManagementQueueItemResponse> =
                await Api.post(urls.GET_MANAGEMENT_ITEM_DATA, dataRequest);
              if (dataResponse.ok) {
                managementItems.push(dataResponse.data.managementItem);
              }
              if(managementItems.length == response.data.searchResult.length)
              {
                this.setState({
                  deletedReports: managementItems, //response.data.managementItems,
                  deleteQueueTotal: response.data.totalResults
                });
                this.setState({ loadingDeleteQueue: false });
              }
            });
          }
          else {
            this.setState({
              loadingDeleteQueue: false,
              deletedReports: null, //response.data.managementItems,
              deleteQueueTotal: 0
            });
          }
        }
    } catch (ex) {
      this.setState({ loadingDeleteQueue: false });
      console.log(ex);
    } finally {
    }
  };

  getDeletedData = async () => {
    try {
      const request: ManagementQueuePagedRequest = {
        ...this.state.deletedPagingCriteria,
        pageNumber: 1,
        itemsPerPage: this.state.deleteQueueTotal,
        startDate: this.state.startDate.toDate(),
        endDate: this.state.endDate.toDate(),
        getDeleted: true
      };

      const response: ApiResponse<IManagementQueuePagedResponse> =
        await Api.post(urls.GET_REPORTS_IN_MANAGEMENT_QUEUE_EXPORT, request);

      if (response.ok) {
        return response.data.managementItems || [];
      }
    } catch (ex) {
      console.log(ex);
    }
    return [];
  };

  workTheCase = (workflowItemStepId: number) => {
    let location: IAppRouteLocation = {
      pathname: "/ManageReport"
    };

    location.state = {
      workflowItemStepId: workflowItemStepId
    };

    this.props.history.push(location);
  };

  onUpdateActiveStatus = (active: any) => {
    if (active) {
      this.setState({
        pendingAction: "deleteReport",
        showCommentModal: true
      });
      this.pendingAction = "deleteReport";
    } else {
      this.setState({
        pendingAction: "undeleteReport",
        showCommentModal: true
      });
      this.pendingAction = "undeleteReport";
    }
  };

  handleStatus = (item: ExtendedManagementQueueItem) => {
    this.rowData = item;
    this.id = item.id;
    this.setState({
      showCommentModal: true
    });
  };

  setStatus = (item: ExtendedManagementQueueItem) => {
    //Just send over the workflowItemId and handle the reports on the backend

    let active;

    if (item.paperReportId != null) {
      active = item.paperReportActive;

      this.setState({
        reportIdValue: item.paperReportId
      });
      this.reportIdValue = item.paperReportId;
      this.onUpdateActiveStatus(active);
    }

    if (item.crashReportId != null) {
      active = item.crashReportActive;

      this.setState({
        reportIdValue: item.crashReportId
      });
      this.reportIdValue = item.crashReportId;
      this.onUpdateActiveStatus(active);
    }

    new Promise<void>(async (resolve, reject) => {
      await this.updateActiveStatus(item.workflowItemId).then((r) => true);
      resolve();
    }).then(async () => {
      this.props.showLoadingWithMessage(false);
    });

    this.doSearch();
  };

  removeReportFromManagement = (workflowItemStepId: number) => {
    Api.post(urls.REMOVE_FROM_MANAGEMENT_QUEUE, workflowItemStepId).then(
      (response: ApiResponse<any>) => {
        if (response.ok) {
          this.loadManageData();
        }
      }
    );
  };

  handleReportChecked = (id: number, checkboxElement: any) => {
    if (this.state.linkReportStatus == eLinkReportToggleStatus.LinkReports) {
      let currentReportIds = this.state.reportIdsToLink;
      if (id != null) {
        if (checkboxElement) {
          currentReportIds.push(id);
        } else {
          currentReportIds = currentReportIds.filter((x) => x != id);
        }
        this.setState({ reportIdsToLink: currentReportIds });
      }
    }
  };

  handleUnLinkReportChecked = (id: number, checked: any) => {
    let currentUnLinkReportIds = this.state.reportIdsToUnLink;
    if (id != null) {
      if (checked) {
        currentUnLinkReportIds.push(id);
      } else {
        currentUnLinkReportIds = currentUnLinkReportIds.filter((x) => x != id);
      }
      this.setState({ reportIdsToUnLink: currentUnLinkReportIds });
    }
  };

  updateActiveStatus = (workflowItemId: number): Promise<any> => {
    return Api.post(urls.SET_ACTIVE_STATUS, {
      workflowItemId: workflowItemId,
      comment: this.state.comment
    }).then((result: ApiResponse<any>) => {
      if (result.data) {
        if(result.data.success)
        {
          toast.success("Report Deleted");
          console.debug("Delete:", result);
        } else {
          toast.error("Failed to Delete");
          console.debug("Delete:", result);
        }
      }
      this.loadDeletedData();
      this.loadManageData();
    });
  };

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case "comment":
        this.setState({
          comment: el.value
        });
        break;
      case "originalCrashKeyToLink":
        this.setState(
          {
            originalCrashKeyToLink: el.value,
            originalCrashKeyValid: el.value.length == 9
          },
          () => {
            if (this.state.originalCrashKeyValid) {
              this.props.getKeywordsByCrashKey(
                this.state.originalCrashKeyToLink
              );
            }
          }
        );
        break;
      default:
        break;
    }
  };

  linkByCrashKey = (reportId: number) => {
    this.setState({
      showLinkByCrashKey: true,
      manualLinkToReportId: reportId
    });
  };

  onCreateLink = (linkToReportId) => {
    let groupKey = this.generateRandomString(12);

    Api.post(urls.SET_REPORT_GROUPING_KEY, {
      GroupingKey: groupKey,
      ids: [this.state.manualLinkToReportId, linkToReportId]
    }).then((response: ApiResponse<any>) => {
      if (response && response.ok) {
        this.setState({ showLinkByCrashKey: false }, () => {
          this.loadManageData();
          toast.success("Reports Linked");
        });
      } else {
        toast.error("Error Linking");
      }
    });
  };

  cancelComment = () => {
    this.setState({
      comment: "",
      showCommentModal: false
    });
  };

  onSaveLinking = () => {
    if (this.state.linkReportStatus == eLinkReportToggleStatus.UnlinkReports) {
      this.onUnlinkReports();
    }
    if (this.state.linkReportStatus == eLinkReportToggleStatus.LinkReports) {
      this.onLinkReports();
    }
  };

  onLinkReports = () => {
    this.setState({
      pendingAction: "linkReports",
      showCommentModal: true
    });
    this.pendingAction = "linkReports";
  };

  onUnlinkReports = () => {
    this.setState({
      pendingAction: "unlinkReports",
      showCommentModal: true
    });
    this.pendingAction = "unlinkReports";
  };

  saveComment = () => {
    if (
      this.state.pendingAction == "unlinkReports" ||
      this.state.pendingAction == "linkReports"
    ) {
      this.linkReports();
      this.createManagementLog();
      this.closeModel();
      return;
    }

    this.setStatus(this.rowData);
    this.createManagementLog();
    this.closeModel();
  };

  createManagementLog = () => {
    const newManagementLog: IAuditLogBase = {
      elasticIndex: ElasticIndices.Administration,
      logCategory: LogCategoryEnum.StatusChange,
      logLevel: LoggingLevel.Audit
    };

    const logData = {
      action: this.pendingAction,
      userComment: this.state.comment,
      reportId: this.reportIdValue
    };

    this.props.createManagementAuditLog(newManagementLog, logData);
  };

  toggleScrollLock = () => {
    document.querySelector("html").classList.toggle("scroll-lock");
  };

  closeModel = () => {
    this.setState({
      showCommentModal: false,
      pendingAction: "",
      comment: ""
    });
  };

  toggleReportLinking = () => {
    this.setState(
      { linkReportStatus: eLinkReportToggleStatus.LinkReports },
      () => {
        this.reportLinking();
      }
    );
  };

  toggleReportUnLinking = () => {
    this.setState(
      { linkReportStatus: eLinkReportToggleStatus.UnlinkReports },
      () => {
        this.reportLinking();
      }
    );
  };

  cancelLinking = () => {
    this.setState({
      linkReportStatus: eLinkReportToggleStatus.None,
      reportLinkStatus: eReportLink.ToggleLinkReports,
      showLinkChkbxColumn: false,
      showUnLinkChbxColumn: false,
      reportIdsToLink: [],
      reportIdsToUnLink: []
    });
  };

  reportLinking = () => {
    this.setState({
      reportLinkStatus:
        this.state.reportLinkStatus == eReportLink.ToggleLinkReports
          ? eReportLink.SaveReportLinks
          : eReportLink.ToggleLinkReports,
      showLinkChkbxColumn:
        this.state.linkReportStatus == eLinkReportToggleStatus.LinkReports,
      showUnLinkChbxColumn:
        this.state.linkReportStatus == eLinkReportToggleStatus.UnlinkReports
    });
  };

  handleSplitMerge(rowData: any) {
    console.log(
      "grouping key value: ",
      rowData.workflowItemStep.workflowItem.report.groupingKey
    );
  }

  handleDetails(rowData: any) {
    //Get audit log data?
    console.log(
      "grouping key value: ",
      rowData.workflowItemStep.workflowItem.report.groupingKey
    );
  }

  linkReports = () => {
    let selectedItemIds;
    if (this.state.linkReportStatus == eLinkReportToggleStatus.LinkReports)
      selectedItemIds = this.state.reportIdsToLink;
    if (this.state.linkReportStatus == eLinkReportToggleStatus.UnlinkReports)
      selectedItemIds = this.state.reportIdsToUnLink;
    let groupKey = this.generateRandomString(12);
    if (this.state.linkReportStatus == eLinkReportToggleStatus.LinkReports) {
      Api.post(urls.SET_REPORT_GROUPING_KEY, {
        GroupingKey: groupKey,
        ids: selectedItemIds
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          this.setState(
            {
              reportLinkStatus: eReportLink.ToggleLinkReports,
              reportIdsToLink: [],
              showLinkChkbxColumn: !this.state.showLinkChkbxColumn,
              linkReportStatus: eLinkReportToggleStatus.None
            },
            () => {
              this.loadManageData();
            }
          );
        }
      });
    }

    if (this.state.linkReportStatus == eLinkReportToggleStatus.UnlinkReports) {
      Api.post(urls.REMOVE_REPORTS_GROUPING_KEY, {
        GroupingKey: groupKey,
        ids: selectedItemIds
      }).then((response: ApiResponse<any>) => {
        if (response.ok) {
          this.setState(
            {
              reportLinkStatus: eReportLink.ToggleLinkReports,
              reportIdsToUnLink: [],
              showUnLinkChbxColumn: !this.state.showUnLinkChbxColumn,
              linkReportStatus: eLinkReportToggleStatus.None
            },
            () => {
              this.loadManageData();
            }
          );
        }
      });
    }

    this.setState({ linkReportStatus: eLinkReportToggleStatus.Done }, () => {
      this.doSearch();
    });
  };

  generateRandomString = (length: number) => {
    let result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  setLocalStorageItem(key, value) {
    window.localStorage.setItem(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.log(error);
    }
  }

getLocalStorageItem(key) {
  try {
    const item = window.localStorage.getItem(key);
    if (!item) return false;

    // if you stored empty string as "cleared"
    if (item.trim() === "") return false;

    const m = moment(item); // parses ISO well
    return m.isValid() ? m : false;
  } catch (error) {
    console.log(error);
    return false;
  }
}

  setTab(key) {
    this.setState({
      tabKey: key
    }, () => {
      if (key == "Deleted" && this.state.deleteQueueTotal == 0) {
        this.doSearch();
      }
    });
  }

  handleAddEditKeywords() {
    this.setState({
      showAddEditKeywordsModal: true
    });
  }

  handlePullReportClick() {
    this.setState({
      showPullReportModal: true
    });
  }

  handleManagePagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ managePagingCriteria: pagingCriteria as any }, () => {
      this.loadManageData();
    });
  };

  handleDeletedPagingCriteriaChange = (pagingCriteria: PagedResultsRequest) => {
    this.setState({ deletedPagingCriteria: pagingCriteria as any }, () => {
      this.loadDeletedData();
    });
  };

  handleClearDateSelection = (): void => {
    LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
    LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
    this.setState(
      {
        startDate: moment(
          moment().startOf("month").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        ),
        endDate: moment(
          moment().endOf("month").format("DD/MM/YYYY"),
          "DD/MM/YYYY"
        )
      },
      () => {
        this.doSearch();
      }
    );
  };

    handleResetSearchCriteria = (): void => {
      LocalStorageUtils.removeLocalStorageItem(this.managementPageCriteriaVariable);
      LocalStorageUtils.removeLocalStorageItem(this.startDateVariable);
      LocalStorageUtils.removeLocalStorageItem(this.endDateVariable);
      sessionStorage.removeItem(this.managementPageCriteriaVariable);
      
      this.state = initialState;

      location.reload();
  };
  

  exportColumnMaps: IExportColumnMap[] = [
    { columnName: "ID", propertyName: "id" },
    { columnName: "CRASH KEY", propertyName: "originalCrashKey" },
    {
      columnName: "DATE OF CRASH",
      propertyName: "crashDateTime",
      convertMethod: (val) =>
        val ? moment(val).format("MM/DD/yyyy") : ""
    },
    { columnName: "STREET NAME", propertyName: "streetName" },
    { columnName: "COUNTY", propertyName: "county" },
    { columnName: "AGENCY NAME", propertyName: "agencyName" },
    { columnName: "ROUTED FROM", propertyName: "routedWorkflowStepName" },
    { columnName: "GROUP KEY", propertyName: "groupingKey" }
  ];

  deletedColumns: TableColumn<ExtendedManagementQueueItem>[] = [    
    {
      name: "CRASH KEY",
      sortField: "CrashKey",
      wrap: true,
      selector: (row: ExtendedManagementQueueItem) =>
        row?.originalCrashKey || "",
      sortable: true
    },
    {
      name: "CRASH DATE",
      sortable: true,
      sortField: "CrashDateTime",
      wrap: true,
      selector: (row: ExtendedManagementQueueItem) =>
        row?.crashDateTime
          ? moment(row.crashDateTime).format("MM/DD/yyyy")
          : ""
    },
    {
      name: "STREET NAME",
      sortField: "StreetName",
      wrap: true,
      selector: (row: ExtendedManagementQueueItem) => row?.streetName || "",
      sortable: true
    },
    {
      name: "COUNTY",
      sortField: "County",
      wrap: true,
      selector: (row: ExtendedManagementQueueItem) => row?.county || "",
      sortable: true
    },
    {
      name: "AGENCY NAME",
      sortField: "AgencyName",
      wrap: true,
      selector: (row: ExtendedManagementQueueItem) => row?.agencyName || "",
      sortable: true
    },
    {
      name: "ROUTED FROM",
      sortField: "RoutedWorkflowStepName",
      wrap: true,
      selector: (row: ExtendedManagementQueueItem) =>
        row?.routedWorkflowStepName || "",
      sortable: true
    }
  ];

  render() {
  
const manageColumns: TableColumn<ExtendedManagementQueueItem>[] = [
  {
    id: 1,
    name: "AVAILABLE ACTIONS",
    selector: (row) => row?.id,
    sortField: "Id",
    sortable: true,
    wrap: true,
    format: (rowData: ExtendedManagementQueueItem) => {
      return (
        <div className="buttonColumn">
          <Provider store={reduxStore}>
            <ViewAllButton
              reportId={rowData.reportId}
              className="breakPoint"
              text="View"
              managementMode="true"
            />
          </Provider>
          {"   "}
          {isGranted(permissions.DeleteReports, this.props.currentUser) && (
            <Button
              variant="outline-danger"
              size="sm"
              onClick={() => this.handleStatus(rowData)}
              className="breakPoint"
            >
              Delete
            </Button>
          )}
          {"   "}
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => this.workTheCase(rowData.id)}
            className="breakPoint"
          >
            Work
          </Button>
          {"   "}
          <Button
            variant="outline-info"
            size="sm"
            onClick={() => this.removeReportFromManagement(rowData.id)}
          >
            Send Back To Queue
          </Button>
          <br />
          <Provider store={reduxStore}>
            <ViewTvalFormButton
              reportId={rowData.reportId}
              buttonText="View Form"
              className="mt-10"
            />
            {"  "}
            <CommentsButton
              reportId={rowData.reportId}
              className="btn-sm mt-10"
              placement="right"
              report={rowData.report}
            />
          </Provider>
        </div>
      );
    }
  },
  {
    id: 2,
    name: "ACTION TAKEN",
    selector: (row) => row?.id,
    sortField: "Id",
    sortable: false,
    wrap: true,
    format: (rowData: ExtendedManagementQueueItem) => {
      return (
        <div>
          <dl>
            <div>
              <dt>{rowData.groupingKey == null ? "" : <b>Linked Key: </b>}</dt>
              <dd>{rowData.groupingKey}</dd>
            </div>
            <div>
              <dt>
                {rowData.associatedCrashKeys == null ? "" : <b> Crash Keys: </b>}
              </dt>
              <dd>{rowData.associatedCrashKeys}</dd>
            </div>
          </dl>

          <dl>
            <dt>{rowData.mergeStatus == null ? "" : <b>Merged Status: </b>}</dt>
            <dd>{rowData.mergeStatus}</dd>
          </dl>

          <dl>
            <dt>{rowData.mergeStatus == null ? "" : <b>Split Status: </b>}</dt>
            <dd>{rowData.mergeStatus}</dd>
          </dl>
        </div>
      );
    }
  },
  {
    id: 3,
    name: "CRASH KEY",
    sortField: "originalCrashKey",
    wrap: true,
    selector: (row: ExtendedManagementQueueItem) => row?.originalCrashKey || "",
    sortable: true,
    format: (row: ExtendedManagementQueueItem) => (
      <div>
        {row?.originalCrashKey || ""}
        <MergedIndicator
          supplementedReports={row.supplementedReports}
          reportsMergedToThis={row.reportsMergedToThis}
        />
        <CompletedIndicator completedDate={row.report && row.report.completedDate} />
        <DriverReportMergedIndicator hasMergedDriverReport={row.hasMergedDriverReport} />
      </div>
    )
  },
  {
    id: 4,
    name: "CRASH DATE",
    sortable: true,
    sortField: "CrashDateTime",
    wrap: true,
    selector: (row: ExtendedManagementQueueItem) =>
      row?.crashDateTime ? moment(row.crashDateTime).format("MM/DD/yyyy") : ""
  },
  {
    id: 5,
    name: "STREET NAME",
    sortField: "StreetName",
    wrap: true,
    selector: (row: ExtendedManagementQueueItem) => row?.streetName || "",
    sortable: true
  },
  {
    id: 6,
    name: "COUNTY",
    sortField: "County",
    wrap: true,
    selector: (row: ExtendedManagementQueueItem) => row?.county || "",
    sortable: true
  },
  {
    id: 7,
    name: "AGENCY NAME",
    sortField: "AgencyName",
    wrap: true,
    selector: (row: ExtendedManagementQueueItem) => row?.agencyName || "",
    sortable: true
  },
  {
    id: 8,
    name: "ROUTED FROM",
    sortField: "RoutedWorkflowStepName",
    wrap: true,
    selector: (row: ExtendedManagementQueueItem) =>
      row?.routedWorkflowStepName || "",
    sortable: true
  },
  {
    id: 9,
    name: "LINK REPORTS",
    selector: (row) => row?.id,
    wrap: true,
    sortable: false,
    omit: !this.state.showLinkChkbxColumn,
    format: (rowData: ExtendedManagementQueueItem) => (
      <div style={{ textAlign: "center" }}>
        {rowData.reportId != null && (
          <label>
            <input
              type="checkbox"
              key={rowData.id}
              checked={this.state.reportIdsToLink.some((x) => x == rowData.reportId)}
              onChange={(ev) =>
                this.handleReportChecked(rowData.reportId, ev.currentTarget.checked)
              }
            ></input>
            &nbsp;Link
          </label>
        )}
        <br />
        <Button
          variant="outline-info"
          size="sm"
          onClick={() => this.linkByCrashKey(rowData.reportId)}
        >
          Link by Crash Key
        </Button>
      </div>
    )
  },
  {
    id: 10,
    name: "UN-LINK REPORTS",
    selector: (row) => row?.id,
    wrap: true,
    sortable: false,
    omit: !this.state.showUnLinkChbxColumn,
    format: (rowData: ExtendedManagementQueueItem) => (
      <div style={{ textAlign: "center" }}>
        {rowData.reportId != null && (
          <label>
            <input
              type="checkbox"
              key={rowData.id}
              checked={this.state.reportIdsToUnLink.some((x) => x == rowData.reportId)}
              onChange={(ev) =>
                this.handleUnLinkReportChecked(rowData.reportId, ev.currentTarget.checked)
              }
            ></input>
            &nbsp;Un-Link
          </label>
        )}
      </div>
    )
  }
];



    return (
      <React.Fragment>
          <div className="row">
            <div className="col-sm-6">
              <h3>Management Queue</h3>
            </div>
            <div className="col-sm-6 text-right">
              <button
                      className="btn btn-default btn-sm"
                      title="Reset Search Criteria"
                      onClick={this.handleResetSearchCriteria}>
                      Reset Search Criteria
                    </button>
            </div>
          </div>
        <hr style={{width: "100%" }} />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="dataEntryQueueStartDate">
              <Form.Label>Date of Crash</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId="dataEntryQueueStartDate" // PropTypes.string.isRequired,
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId="dataEntryQueueEndDate" // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
              {(LocalStorageUtils.getLocalStorageDate(this.startDateVariable) ||
                LocalStorageUtils.getLocalStorageDate(
                  this.endDateVariable
                )) && (
                  <button
                    className="btn btn-outline-danger btn-sm"
                    style={{ fontSize: "14px", marginLeft: "5px" }}
                    title="Clear Date Filter"
                    onClick={this.handleClearDateSelection}
                  >
                    <i className="fa fa-calendar-xmark" />
                  </button>
                )}
            </Form.Group>

            <Form.Group
              controlId="formBasicCheckbox"
              style={{
                display: "flex",
                marginBottom: "-10px",
                alignItems: "flex-start",
                flexWrap: "wrap",
                justifyContent: "flex-end",
                gap: ".25rem"
              }}
              as={Col}
            >
              <Button
                onClick={() => this.handlePullReportClick()}
                variant="secondary"
              >
                Pull Report
              </Button>
              {isGranted(
                permissions.AddEditKeywords,
                this.props.currentUser
              ) && (
                  <Button
                    onClick={() => this.handleAddEditKeywords()}
                    variant="secondary"
                  >
                    Add/Edit Keywords
                  </Button>
                )}
              {isGranted(permissions.LinkReports, this.props.currentUser) &&
                <>
                  {this.state.linkReportStatus == eLinkReportToggleStatus.None && (
                    <Button
                      onClick={() => this.toggleReportLinking()}
                      variant={"dark"}
                    >
                      Link Reports
                    </Button>
                  )}
                  {this.state.linkReportStatus == eLinkReportToggleStatus.None && (
                    <Button
                      onClick={() => this.toggleReportUnLinking()}
                      variant={"dark"}
                    >
                      Un-Link Reports
                    </Button>
                  )}
                </>
              }
              {this.state.reportLinkStatus == eReportLink.SaveReportLinks &&
                this.state.linkReportStatus != eLinkReportToggleStatus.None && (
                  <React.Fragment>
                    <Button
                      onClick={this.cancelLinking}
                      className="pull-right"
                      variant={"danger"}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => this.onSaveLinking()}
                      className="pull-right"
                      style={{ marginRight: "5px" }}
                    >
                      Save
                    </Button>
                  </React.Fragment>
                )}
            </Form.Group>
          </Form.Row>
        </Form>

        <Tabs defaultActiveKey="Management" id="uncontrolled-tab-example" activeKey={this.state.tabKey}
          onSelect={(k) => this.setTab(k)}>
          <Tab eventKey="Management" title="Management">
            <PagedDatatable
              columns={manageColumns}
              
              data={this.state.data || []}
              loadingData={this.state.loadingManageQueue}
              totalDataItems={this.state.manageQueueTotal}
              exportTitle="Management Queue"
              exportFileName="ManagementQueue"
              exportColumnMaps={this.exportColumnMaps}
              pagingCriteria={this.state.managePagingCriteria}
              updatePagedResults={this.handleManagePagingCriteriaChange}
              getExportData={this.getManageExportData}
            ></PagedDatatable>
          </Tab>
          <Tab eventKey="Deleted" title="Deleted">
            <PagedDatatable
              columns={this.deletedColumns}
              data={this.state.deletedReports || []}
              loadingData={this.state.loadingDeleteQueue}
              totalDataItems={this.state.deleteQueueTotal}
              exportTitle="Deleted Queue"
              exportFileName="DeletedQueue"
              exportColumnMaps={this.exportColumnMaps}
              pagingCriteria={this.state.deletedPagingCriteria}
              updatePagedResults={this.handleDeletedPagingCriteriaChange}
              getExportData={this.getDeletedData}
            ></PagedDatatable>
          </Tab>
        </Tabs>

        <CommentModal
          comment={this.state.comment}
          show={this.state.showCommentModal}
          onCommentChange={this.handleChange}
          onCloseCommentModal={this.cancelComment}
          onCancel={this.cancelComment}
          onSave={this.saveComment}
        />

        <Modal
          show={this.state.showLinkByCrashKey}
          onHide={this.onCloseLinkByCrashKey}
        >
          <Modal.Header closeButton>
            <Modal.Title>Link Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form>
                <Form.Group controlId="linkedCrashKey">
                  <Form.Label>
                    <strong>Crash Key</strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    data-field="originalCrashKeyToLink"
                    placeholder="Enter Crash Key"
                    onChange={this.handleChange}
                    value={this.state.originalCrashKeyToLink}
                  />
                </Form.Group>
              </Form>
              {this.props.linkReport && this.state.originalCrashKeyValid && (
                <div>
                  <b>Crash Date: </b>{" "}
                  {this.props.linkReport.keywords.dateOfCrash}
                  <br />
                  <b>County: </b>{" "}
                  {this.props.linkReport.keywords.county?.description}
                  <br />
                  <b>Involved Parties: </b>{" "}
                  {this.props.linkReport.keywords?.involvedParties?.map(
                    (ip) => {
                      return (
                        ip.firstName +
                        " " +
                        ip.lastName +
                        " " +
                        (ip.businessName || "") +
                        ", "
                      );
                    }
                  )}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.onCloseLinkByCrashKey}>
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={(e) => this.onCreateLink(this.props.linkReport.id)}
              disabled={!this.state.originalCrashKeyValid}
            >
              Create Link
            </Button>
          </Modal.Footer>
        </Modal>

        <AddEditKeywordsModal
          show={this.state.showAddEditKeywordsModal}
          onHide={() => this.setState({ showAddEditKeywordsModal: false })}
        />

        <PullReportModal
          show={this.state.showPullReportModal}
          onHide={() => this.setState({ showPullReportModal: false })}
          onAfterPullingIntoManagement={() => this.doSearch()}
        />
      </React.Fragment>
    );
  }
}

export function mapStateToProps(reduxState: any) {
  return {
    webServiceURL: reduxState.Application.backendURL,
    currentUser: reduxState.Application.currentUser,
    workflowStepsLoading: reduxState.WorkflowQueues.WorkFlowStepsLoading,
    workflowSteps: reduxState.WorkflowQueues.WorkFlowSteps,
    linkReport: reduxState.Management.linkReport
  };
}

const mapDispatchToProps = {
  showLoadingWithMessage,
  createManagementAuditLog,
  getKeywordsByCrashKey
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagementQueueControllerPaged);
